var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { lookupPublisherByCompanyNumber } from "../api/publisherService";
import { PublisherLegalFormEnum } from "../types/Api";
import { ErrorType } from "../types/ErrorType";
export var usePublisherGeneral = function (setValue, watch, icoLoadedCallback, setIcoError) {
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var legalFormValue = watch("legalForm");
    var companyNumber = watch("companyNumber");
    useEffect(function () {
        if (legalFormValue === PublisherLegalFormEnum.LEGAL) {
            setValue("birthDate", "", { shouldValidate: true });
        }
    }, [legalFormValue, setValue]);
    var _a = useQuery(["publisher", companyNumber], function () { return lookupPublisherByCompanyNumber(ky, companyNumber !== null && companyNumber !== void 0 ? companyNumber : ""); }, {
        enabled: false,
        retry: false,
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var translatedError, httpError, data, currentError, _a;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        translatedError = "";
                        if (!(error !== null &&
                            typeof error === "object" &&
                            "response" in error)) return [3 /*break*/, 4];
                        httpError = error;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, httpError.response.json()];
                    case 2:
                        data = _d.sent();
                        currentError = (_b = data === null || data === void 0 ? void 0 : data.errors) === null || _b === void 0 ? void 0 : _b[0];
                        translatedError = (_c = currentError === null || currentError === void 0 ? void 0 : currentError.message) !== null && _c !== void 0 ? _c : "";
                        if ((currentError === null || currentError === void 0 ? void 0 : currentError.type) === ErrorType.INTERNAL &&
                            (currentError === null || currentError === void 0 ? void 0 : currentError.code) === "NOT_FOUND_ERROR") {
                            translatedError = formatMessage({ id: "ui-br-legaldeposits.error.aresDataNotFound" }, { ico: companyNumber });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _d.sent();
                        console.error("Error parsing json");
                        return [3 /*break*/, 4];
                    case 4:
                        setIcoError(translatedError);
                        return [2 /*return*/];
                }
            });
        }); },
    }), isIcoFetching = _a.isFetching, refetchIco = _a.refetch;
    var handleIco = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, icoPublisher, isError, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    if (!companyNumber || companyNumber.trim() === "") {
                        setIcoError(formatMessage({
                            id: "ui-br-legaldeposits.error.companyNumber.required",
                        }));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, refetchIco()];
                case 1:
                    _a = _b.sent(), icoPublisher = _a.data, isError = _a.isError;
                    if (isError)
                        return [2 /*return*/];
                    icoLoadedCallback(icoPublisher);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    console.error("Error fetching Ares data:", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return {
        legalFormValue: legalFormValue,
        handleIco: handleIco,
        isIcoFetching: isIcoFetching,
    };
};
